import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth, useChangelog } from '../../zustand/Zustand';
import { ChangelogModal } from './ChangelogDialog';

const ChangelogHandler: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const { unseenEntries, hasFetched, fetchChangelog, markAllSeen } = useChangelog();
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    if (isAuthenticated && !hasFetched) {
      fetchChangelog();
    }
  }, [isAuthenticated, hasFetched, fetchChangelog]);

  const isHomePage = location.pathname === '/';
  const showModal = hasFetched && unseenEntries.length > 0 && !dismissed && !isHomePage;

  const handleClose = () => {
    setDismissed(true);
    markAllSeen();
  };

  if (!showModal) return null;

  return <ChangelogModal entries={unseenEntries} onClose={handleClose} />;
};

export default ChangelogHandler;
